<template>
    <div class="wrap">
        <div class='main'>
            <img class='big-img' src="~src/assets/image/permission.png">
            <div class="text">
                <img src="~src/assets/image/permission-logo.png">
                <div>
                    <div>很抱歉</div>
                    <div>您没有权限访问，请联系超级管理员<span class="green" @click="link">返回首页</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods:{
            link(){
                this.$router.replace({name:'dashboard'});
            }
        },
    }
</script>

<style lang="less" scoped>
    @import '~src/assets/less/var.less';
    .wrap{
        height: 100%;
        position: relative;
        background:#fff;
        .main{
            position: absolute;
            left: 50%;
            top:40%;
            transform: translate(-50%,-50%);
        }
    }

    .big-img{
        display: block;
        margin-bottom: 20px;
    }
    .text{
        color:#7e8e9f;
        font-size: 0;
        padding-left: 30px;
        img{
            margin-right: 15px;
        }

        >div{
            display: inline-block;
            font-size:24px;
            >div:last-child{
                font-size:18px;
            }
        }
    }

    // 返回首页
    .green{
        display:inline-block;
        margin-left: 10px;
        transition: 0.3s;
        color:@main-c;
        cursor: pointer;
        &:hover{
            color:@main-hover;
        }
        &:active{
            color:@main-active;
        }
    }
</style>





// WEBPACK FOOTER //
// page-noPermission.vue?41010110